export default __webpack_public_path__ + "static/media/Tebow.82b5bbd7.jpg";